import { boxSlotKeys } from "@/modules/boxSlot/gateway/boxSlotKeys"
import { BoxSessionDetailsEntity } from "@/modules/boxSlotSession/entities/boxSessionEntity"
import type { BoxSessionCreateInputDto } from "@/modules/boxSlotSession/gateway/boxSlotSessionDto"
import { boxSlotSessionKeys } from "@/modules/boxSlotSession/gateway/boxSlotSessionKey"
import { useServicesContext } from "@/modules/core/services/services.context"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export function useBoxSlotCreateSession() {
  const { boxSlotSessionApi } = useServicesContext()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ sessionCreateInputDto }: { sessionCreateInputDto: BoxSessionCreateInputDto }) => {
      const result = await boxSlotSessionApi.createSession(sessionCreateInputDto)
      return BoxSessionDetailsEntity.fromDto(result)
    },
    onSuccess: async (data) => {
      await queryClient.setQueryData(boxSlotSessionKeys.session(data.id), data)
      await queryClient.invalidateQueries({
        queryKey: boxSlotKeys.all,
      })
    },
  })
}
